import { render } from "./AdminTours.vue?vue&type=template&id=29ae8bfd&scoped=true"
import script from "./AdminTours.vue?vue&type=script&lang=js"
export * from "./AdminTours.vue?vue&type=script&lang=js"

import "./AdminTours.vue?vue&type=style&index=0&id=29ae8bfd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ae8bfd"]])

export default __exports__